import { ICurrency } from 'interfaces/ICurrency';
import { useCallback, useMemo } from 'react';
import { useFetch } from './useFetch';

export const useCurrencyService = () => {
  const { callApi } = useFetch();
  interface ICurrencyResponse {
    Currencies: ICurrency[];
  }

  const getAll = useCallback(async () => {
    const result = await callApi<ICurrencyResponse>({
      url: `Currency/GetAll`,
      method: 'get',
      prefixMsgError: 'error in ProductService - getAll:'
    });
    return result;
  }, [callApi]);

  // const getAll = useCallback(async () => {
  //   // Retornando dados mockados
  //   const mockData: ICurrencyResponse = {
  //     Currencies: [
  //       { Id: 1, Symbol: 'R$', Description: 'Real Brasileiro' },
  //       { Id: 2, Symbol: '$', Description: 'Dólar Americano' },
  //       { Id: 3, Symbol: '€', Description: 'Euro' },
  //       { Id: 4, Symbol: '$', Description: 'Peso Argentino' }
  //     ]
  //   };
  //   return mockData; // Simulando o retorno da API
  // }, []);

  return useMemo(
    () => ({
      currencyService: {
        getAll
      }
    }),
    [getAll]
  );
};
